package pwgs.ui.scenes.login

import kotlinx.browser.document
import kotlinx.browser.window
import visage.core.Navigation


class LoginControllerFe(props: LoginSceneProps, scene: MLoginScene) : ALoginControllerFe(props, scene) {

    override fun createInitialModel() : LoginSceneModel {
        return LoginSceneModel(null)
    }

    override fun init() {}

    fun handleLoginClicked() {
        val baseUrl = window.location.href
        console.info(baseUrl)
        launchOnDefaultControllerScope {
            val res = this@LoginControllerFe.backend.login(baseUrl)
            if (res.loginUrl != null) {
                window.location.href = res.loginUrl
            }
        }
    }


}

